"use strict";

let isSelect2Loaded = false; // Flag to track if Select2 has been loaded and initialized
export const initSelect2 = async (selector) => {
	const firstSelect = document.querySelector(selector);
	if (!firstSelect) return;
	
    // Check if Select2 has already been loaded/initialized
	try {
		const { default: select2Initializer } = await import('select2');
		if (!isSelect2Loaded) {
			// This registers the .select2() jQuery plugin
			select2Initializer(window, $);
			isSelect2Loaded = true; // Mark as loaded
		}
	} catch (error) {
		console.error("Failed to load Select2 dynamically:", error);
		return;
	}

    try {
        $(selector).select2({
            theme: "bootstrap-5",
            width: '100%',
            minimumResultsForSearch: Infinity
        });
    } catch(error) {
        console.error(`Failed to apply Select2 to selector "${selector}":`, error);
    }
};